import { z } from "zod";
import { financeAccountSchema, financeCodeSchema, financeDateSchema, financeEntrySchema } from "./account-finance-contract.js";
import { financeAgingSchema } from "./finance-aging-contract.js";

export const accountOverviewSchema = z.object({ date: financeDateSchema, company: z.string(),
  cursor: financeCodeSchema.nullable(), more: z.boolean(),
  total: z.number().int().nonnegative().max(10000).optional(),
  job: z.object({ id: z.string().uuid(), status: z.enum(["running", "pausing", "paused", "completed", "failed"]),
    startedAt: z.iso.datetime(), updatedAt: z.iso.datetime(), requestedBy: z.string(),
    message: z.string().nullable() }).optional(),
  rows: z.array(z.object({ code: financeCodeSchema, name: z.string(), currency: z.string(),
    account: financeAccountSchema.nullable(), observedAt: z.iso.datetime().nullable(),
    lastPayment: financeDateSchema.nullable(), lastMovement: financeDateSchema.nullable(),
    aging: financeAgingSchema.nullable().optional(), entries: z.array(financeEntrySchema).max(20000).optional(),
    sourceVersion: z.string().regex(/^[a-f0-9]{64}$/u).optional(), listedInRefresh: z.boolean().optional(),
    sourceAmounts: z.array(z.object({ id: z.string(), debit: z.number().finite(), credit: z.number().finite() })).max(20000).optional(),
    readError: z.string().nullable().optional(), lastAttemptAt: z.iso.datetime().nullable().optional() })).max(10000) });
export type AccountOverview = z.infer<typeof accountOverviewSchema>;
